import { on } from "delegated-events";
import { gsap } from "gsap";

const siteMenu = document.querySelector(".site-mobile-menu");

const generateSiteMenuLinePath = () => {
  const svg = document.querySelector(".site-menu-line svg");
  const holder = document.querySelector(".site-menu-line");
  const svgRect = holder.getBoundingClientRect();

  svg.setAttribute("viewBox", `-1 -1 ${svgRect.width} ${svgRect.height}`);

  const pathParts = [`M${svgRect.width} 0`];

  let a = 40;
  let b = 50;

  pathParts.push(`H${b}`);
  pathParts.push(`C${a} 0 0 0 0 ${b}`);
  pathParts.push(`V${svgRect.height}`);

  const pathData = pathParts.join("");

  svg.innerHTML = `<path d="${pathData}" stroke="white" stroke-width="2" fill="none" stroke-dashoffset="2000" stroke-dasharray="2000" />`;
};

const openMenu = () => {
  siteMenu.setAttribute("aria-hidden", "false");
  document.documentElement.classList.add("js-menu-active");

  if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
    gsap.set(".site-menu-close", { opacity: 0 });
    gsap.set(".site-mobile-actions .btn, .site-mobile-nav > ul > li", { y: "60%", opacity: 0 });

    const timeline = gsap.timeline();

    timeline.to(".site-mobile-menu", {
      opacity: 1,
      visibility: "visible",
      duration: 0.4,
      ease: "expoScale(0.5, 7, none)",
    });
    timeline.to(
      ".site-menu-line path",
      {
        strokeDashoffset: 0,
        duration: 1,
        ease: "expoScale(0.5, 7, none)",
      },
      "<80%",
    );
    timeline.to(
      ".site-mobile-actions .btn, .site-mobile-nav > ul > li",
      {
        y: 0,
        opacity: 1,
        duration: 0.4,
        stagger: 0.05,
        ease: "expoScale(0.5, 7, none)",
      },
      "<",
    );
    timeline.to(
      ".site-menu-close",
      {
        opacity: 1,
        duration: 0.4,
        ease: "expoScale(0.5, 7, none)",
      },
      "<50%",
    );
  }
};

const closeMenu = async () => {
  siteMenu.setAttribute("aria-hidden", "true");

  if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
    const timeline = gsap.timeline({
      paused: true,
    });

    timeline.to(
      ".site-mobile-actions .btn, .site-mobile-nav > ul > li",
      {
        y: "60%",
        opacity: 0,
        duration: 0.25,
        ease: "expoScale(0.5, 7, none)",
      },
      "<",
    );

    timeline.to(
      ".site-menu-close",
      {
        opacity: 0,
        duration: 0.3,
        ease: "expoScale(0.5, 7, none)",
      },
      "<",
    );

    timeline.to(
      ".site-menu-line path",
      {
        strokeDashoffset: 2000,
        duration: 0.5,
        ease: "expoScale(0.5, 7, none)",
      },
      "<",
    );

    timeline.to(".site-mobile-menu", {
      opacity: 0,
      visibility: "invisible",
      duration: 0.3,
      ease: "expoScale(0.5, 7, none)",
    });

    await timeline.play();
  }

  document.documentElement.classList.remove("js-menu-active");
};

export default {
  init: () => {
    on("click", ".site-menu-trigger", (e) => {
      const trigger = e.currentTarget;

      if (trigger.getAttribute("aria-expanded") === "true") {
        closeMenu();
      } else {
        openMenu();
      }
    });

    on("click", ".site-menu", (e) => {
      if (!e.target.closest(".site-menu-wrapper")) {
        closeMenu();
      }
    });

    window.addEventListener("resize", () => {
      setTimeout(() => {
        if (window.matchMedia("(max-width: 767px)").matches) {
          generateSiteMenuLinePath();
        }
      }, 125);
    });

    generateSiteMenuLinePath();
  },
};
